import { ElasticSearchFilterKeys } from '@interfaces/models/elasticSearch';
import { AlertCriterionKey } from '@interfaces/models/alertCriterion';

/**
 * FilterToAlertCriterionKeyMap is mapping between
 * ElasticSearch filter key to alert criterion key.
 */
interface FilterToAlertCriterionKeyMap {
  searchKey: ElasticSearchFilterKeys;
  alertKey: AlertCriterionKey;
}

const keyMapping: FilterToAlertCriterionKeyMap[] = [
  { searchKey: 'universe.id', alertKey: 'idUniverse' },
  { searchKey: 'brand.id', alertKey: 'idBrand' },
  { searchKey: 'color.id', alertKey: 'idColors' },
  { searchKey: 'condition.id', alertKey: 'idCondition' },
  { searchKey: 'categoryLvl0.id', alertKey: 'idCategory' },
  { searchKey: 'categoryLvl1.id', alertKey: 'idChildCategory' },
  { searchKey: 'categoryLvl2.id', alertKey: 'idSubcategory' },
  { searchKey: 'model.id', alertKey: 'idModel' },
  { searchKey: 'watchMechanism.id', alertKey: 'idWatchMechanism' },
  { searchKey: 'editorPicks', alertKey: 'tags' },
  { searchKey: 'country', alertKey: 'itemLocations' },
];

const filtersToAlertKeysMap = new Map<ElasticSearchFilterKeys, AlertCriterionKey>(
  keyMapping.map(({ searchKey, alertKey }) => [searchKey, alertKey]),
);

const alertToFilterKeysMap = new Map<AlertCriterionKey, ElasticSearchFilterKeys>(
  keyMapping.map(({ searchKey, alertKey }) => [alertKey, searchKey]),
);

export const filtersToAlertKeysRename = (filter: ElasticSearchFilterKeys): AlertCriterionKey =>
  (filtersToAlertKeysMap.get(filter) ?? filter) as AlertCriterionKey;

export const alertToFilterKey = (key: AlertCriterionKey): ElasticSearchFilterKeys =>
  (alertToFilterKeysMap.get(key) ?? key) as ElasticSearchFilterKeys;
